export const ROUTE_PATHS = {
  DASHBOARD: '/dashboard',
  RUG: '/dashboard/rug',
  PORTFOLIO: '/dashboard/portfolio',
  FACILITY: '/dashboard/portfolio/facility',
  FACILITIES: '/dashboard/portfolio/facilities',
  AIVA: '/dashboard/aiva',
  HOME: '/home',
  COMPANIES: '/dashboard/companies',
  FINANCIALS: '/dashboard/financials',
  DATA_STUDIO: '/dashboard/data-studio',
  SELF_SERVICE_TOOL: '/dashboard/aiva/self-service-tool',
  SHELL_ADMIN: '/dashboard/admin',
};
